'use client';
import styled from 'styled-components';
import { StyledOrderSummary, StyledCopy } from '../OrderSummary/styles';

export const StyledCheckoutInformation = styled.div`
  margin-top: ${props => props.theme.spacing(8)};
  flex-grow: 1;

  @media ${props => props.theme.tabletL} {
    flex-basis: 360px;
    flex-grow: 0;
  }
  @media ${props => props.theme.mobileL} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${StyledOrderSummary} {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
  ${StyledCopy} {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;
